fetchConcastWithInfo